import React from "react";
import { Link, useLocation, Redirect } from "react-router-dom";
import { Box } from "grid-styled";
import { Helmet } from "react-helmet";
import calculateAvailableOptions from "../../calculateAvailableOptions";
import { PageContainer } from "../Grid";
import { H1, H2 } from "../TextStyles";
import { LargeButton } from "../Button";
import seriesImages from "./images";
import { WizardCard, WizardCardContainer } from "../WizardCard";
import SVGIcon from "../SVGIcon";

const getSeriesImg = (_series) => {
  let series;

  series = _series.replace(":", "_");
  if (_series === "2A") series = "TWOA";
  return seriesImages[series];
};

const SeriesDisplay = ({ code, description, name }) => {
  const location = useLocation();

  return (
    <WizardCard
      key={code}
      image={getSeriesImg(code)}
      title={name}
      description={description}
      button={
        <Link
          to={{
            pathname: "/build",
            state: { ...location.state, series: code },
          }}
        >
          <LargeButton secondary>Select {name}</LargeButton>
        </Link>
      }
    />
  );
};

const SelectSeries = () => {
  const location = useLocation();
  const { market, style, upholstered } = location.state || {};

  if (!market || !style) {
    return <Redirect to="/market" />;
  }

  if (style === "foundation" && (!market || !style || !upholstered)) {
    return <Redirect to="/market" />;
  }

  if (style === "MVMT" && !market) {
    return <Redirect to="/market" />;
  }

  const { options } = calculateAvailableOptions({ market, style, upholstered });
  const { data: seriesData } = options.find(({ type }) => {
    return type === "series";
  });
  const series = seriesData.filter(({ code }) => code !== "X");
  return (
    <PageContainer>
      <Helmet>
        <title>Know Your Series?</title>
      </Helmet>
      <H1 mb="2rem">Choose Your Series</H1>
      <H2>Don’t Know Your Series?</H2>

      <Box width={1} my="1rem">
        If you don’t know your series, its not a problem, just click <strong>Build A Chair</strong>{" "}
        below.
      </Box>

      <Box mb="3rem">
        <Link to={{ pathname: "/build", state: { ...location.state } }}>
          <LargeButton>
            Build A Chair <SVGIcon icon="gear" />
          </LargeButton>
        </Link>
      </Box>

      <H2>Know Your Series?</H2>

      <Box width={1} mb="1rem">
        If you know your series, please select it here. This will auto-populate the correct
        configurations offered as a baseline. From there you will be able to customize/modify with
        any available items from within the available options.
      </Box>
      <WizardCardContainer>{series.map(SeriesDisplay)}</WizardCardContainer>
    </PageContainer>
  );
};

export default SelectSeries;
